import React,{Component} from 'react';

export class Home extends Component{
    render(){
        return(
            // el html se define en el método render
            <div>
                <h3>Página de inicio</h3>
            </div>
        )
    }
}
// lo mismo tenemos que añadir en Libro.js y el otro
// cambiando Home por el nombre en cada caso, claro
// cuando terminamos ir arriba en App.js en src